import { Badge, Divider, Row } from "antd"
import * as React from "react"
import { withTranslation, WithTranslation } from "react-i18next"

interface CustomSelectSignProps extends WithTranslation {
    total?: number,
    len?: number,
}

class SelectSign extends React.Component<CustomSelectSignProps> {
    render() {
        const { total, len } = this.props
        return (
            <div>
                <div>
                    {this.props.children}
                </div>
                <Divider style={{ margin: '4px 0' }} />
                <div style={{ margin: '10px',  display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ margin: '4px' }}>
                        {total && len && <Badge
                                className="site-badge-count"
                                count={`${len} / ${total}`}
                            />}
                    </div>
                    <div style={{ textAlign: 'center',  maxWidth: '300px', }}>
                        {this.props.t("Showing only part of the results. Search to find the one you need.")}
                    </div>
                </div>
            </div>
        )
    }
}

const TranslatedSelectSign = withTranslation()(SelectSign)

export const dropdownRender = (menu: React.ReactNode, total: number, len: number) => (
    <TranslatedSelectSign total={total} len={len}>
        {menu}
    </TranslatedSelectSign>
)

export default TranslatedSelectSign